const deleteCompareModalConstants = {
  SHOW_MODAL: 'SHOW_MODAL',
  HIDE_MODAL: 'HIDE_MODAL',
};

export default deleteCompareModalConstants;